<template>
  <v-col sm="12" class="overrideCol">
    <div class="">
      <GmapMap
        :options="{ streetViewControl: false }"
        ref="map"
        :center="{lat: 44.801545, lng:20.458796}"
        :zoom="7"
        :style="'height:60vh;' + style"
        @click="pickCoordinate($event, true)"
        > 
          <GmapMarker v-for="(marker, index) in adaptedDestinations"
            :key="index"
            :clickable="true"
            :draggable="true"
            :position="marker"
            :icon="createGmapMarkerIcon(index + 1, '42c2f5', '000000')"
            @dragend="onDragEnd(marker, $event)"
            :z-index="10"
          >
          </GmapMarker>

          <GmapMarker
            v-if="adaptedSource"
            :clickable="false"
            :draggable="false"
            :position="adaptedSource"
            :icon="createGmapMarkerIconCar('FFA500')"
            :z-index="200"
          >
          </GmapMarker>

          <GmapMarker
            v-if="adaptedEndPoint"
            :clickable="false"
            :draggable="false"
            :position="adaptedEndPoint"
            :icon="createGmapMarkerIconCar('FF0000')"
            :z-index="100"
          >
          </GmapMarker>

          <gmap-polyline v-for="(route, index) in routesAdapted" :key="'poly-' + index"
            v-if="route.visible" :path="route.path"
            :options="{ strokeColor: route.color, strokeWeight : 7 }">
          </gmap-polyline>

      </GmapMap>
    </div>
  </v-col>
</template> 

<script>
import { gmapApi } from 'vue2-google-maps'
import RouteOptimizationMixin from './RouteOptimizationMixin'
import GoogleMapMixin from '../googleMapMixin'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import store from '@/store/store'
import { createGmapMarkerIcon, createGmapMarkerIconCar } from '../../../utils/map/createGmapMarkerIcon'

export default {
  name: 'GoogleRouteOptimization',
  data() {
    return {
      createGmapMarkerIcon: createGmapMarkerIcon,
      createGmapMarkerIconCar: createGmapMarkerIconCar
    }
  },
  mixins: [RouteOptimizationMixin, GoogleMapMixin],
  components: { 'gmap-custom-marker': GmapCustomMarker },
  computed: {
    google: gmapApi,
    adaptedDestinations() {
      return this.destinations.map(x => {
        return {
          lat: x.latlng.lat,
          lng: x.latlng.lng
        }
      })
    },
    routesAdapted() {
      return this.routes
        ? this.routes.map(x => {
            return {
              color: x.color,
              visible: x.visible,
              width: x.width,
              path: x.coordinates.map(x => {
                return {
                  lat: x[0],
                  lng: x[1]
                }
              })
            }
          })
        : []
    },
    adaptedSource() {
      return this.source
        ? this.source.latlng.lat && this.source.latlng.lng
          ? this.source.latlng
          : undefined
        : undefined
    },
    adaptedEndPoint() {
        return this.endPoint
                ? this.endPoint.latlng.lat && this.endPoint.latlng.lng
                  ? this.endPoint.latlng
                  : undefined
                : undefined
    }
  },
  methods: {
    onDragEnd(old, e) {
      store.dispatch('optimization/moveMarker', {
        new: {
          lat: e.latLng.lat(),
          lng: e.latLng.lng()
        },
        old: old
      })
    }
  },
  watch: {
    routes: {
      handler() {
        let routesToZoomIn = []
        for (const route of this.routesAdapted) {
          routesToZoomIn = routesToZoomIn.concat(route.path)
        }
        if (routesToZoomIn.length) {
          this.fitBounds(routesToZoomIn)
        }
      }
    },
    selectedRoute: {
      handler() {
        if (this.selectedRoute && this.selectedRoute.length) {
          this.fitBounds(
            this.selectedRoute.map(x => {
              return {
                lat: x[0],
                lng: x[1]
              }
            })
          )
        } else {
          let routesToZoomIn = []
          for (const route of this.routesAdapted) {
            routesToZoomIn = routesToZoomIn.concat(route.path)
          }
          if (routesToZoomIn.length) {
            this.fitBounds(routesToZoomIn)
          }
        }
      }
    }
  }
}
</script>

<style>
</style>
